"use client";

import { createClient, type ChotcaClient } from "@chotca/sdk";

let installed: ChotcaClient | null = null;

/**
 * Install the SDK instance for the current app. Each app calls this once at
 * boot:
 * - apps/web (Next): BFF proxy `/api/bff`, cookies handled by Next.
 * - SPA (web-employer / web-admin): direct to `https://api.chotca.com` with an
 *   in-memory access token + a refresh interceptor wired into `onUnauthorized`.
 */
export function setSdk(sdk: ChotcaClient): void {
  installed = sdk;
}

export function getSdk(): ChotcaClient {
  if (!installed) {
    throw new Error(
      "@chotca/api-client: SDK not installed. Call setSdk() at app boot.",
    );
  }
  return installed;
}

export function createBrowserSdk(opts: {
  baseUrl: string;
  getAccessToken?: () => Promise<string | null | undefined>;
  onUnauthorized?: () => boolean | void | Promise<boolean | void>;
  extraHeaders?: Record<string, string>;
}): ChotcaClient {
  return createClient({
    baseUrl: opts.baseUrl,
    getAccessToken: opts.getAccessToken,
    onUnauthorized: opts.onUnauthorized,
    extraHeaders: opts.extraHeaders,
  });
}
